import { render } from "./AdminPaymentmethodEdit.vue?vue&type=template&id=6954749d&scoped=true&ts=true&lang=true"
import script from "./AdminPaymentmethodEdit.vue?vue&type=script&lang=ts"
export * from "./AdminPaymentmethodEdit.vue?vue&type=script&lang=ts"

import "./AdminPaymentmethodEdit.vue?vue&type=style&index=0&id=6954749d&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6954749d"]])

export default __exports__